/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/lodash/fp/placeholder.js
 ** module id = 26
 ** module chunks = 0
 **/